import React from 'react';
import { IconProps } from '.';

const SvgColoredFingerPointing = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#FFD653'
        d='M20.396 12.271c0-1.012-.793-1.824-1.767-1.824-.3 0-.58.084-.83.22-.12-.89-.856-1.573-1.742-1.573-.443 0-.85.174-1.161.458-.169-.825-.88-1.444-1.73-1.444-.518 0-.986.239-1.31.606v-5.69c0-1.012-.794-1.824-1.768-1.824-.973 0-1.766.819-1.766 1.824v9.266l-.824-1.862C7.086 9.34 6.48 8.643 6.199 8.38c-.443-.419-1.186-.728-1.86-.425-.9.4-.856 1.192-.512 2.01.836 1.985 1.879 4.807 2.054 6.148.493 3.776 3.152 6.688 6.942 6.688 4.139 0 7.566-3.415 7.573-7.68V12.27Z'
      />
    </svg>
  );
};

export default SvgColoredFingerPointing;
